module.exports = __webpack_public_path__ + "media/application/images/svgs/quote-a48adea58d0cfe57bbad4e76da5bfb9c.svg";